import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'رجوع',
      changePassword: 'تغيير كلمة المرور',
      copiedVaultId: 'نسخ!',
      copyVaultID: 'نسخ هوية Vault',
      create: 'إنشاء',
      next: 'التالي',
      notSure: 'لست واثقًا',
      signUp: 'سجل',
      submit: 'إرسال',
      updatePassword: 'تحديث كلمة المرور',
    },
    Errors: {
      createReportFailed: 'فشل إنشاء التقرير.',
    },
    ReportStatus: {
      CLOSED: 'مغلق',
      INVESTIGATING: 'قيد التحقيق',
      NEW: 'تم الإرسال',
      READ: 'قُرأ',
    },
    general: {
      navbar: {
        caseSettings: 'إعدادات الحالة',
        changePassword: 'تغيير كلمة المرور',
        logOut: 'تسجيل الخروج',
        notifications: 'الإشعارات',
        notificationsDrawer: {
          appFileScanFailed: 'لقد فشل ملف في الفحص الأمني',
          appReportMatch: 'تم مطابقة سجلك في GoTogether',
          appReportReassigned: 'تم تعيين مدير قضية جديد',
          case: 'حالة',
          caseAssigned: 'القضية الموكلة إليك',
          caseImporterJobCompleted: {
            PartialSuccess: 'تم اكتمال استيراد الحالة الخاصة بك مع وجود أخطاء',
            failure: 'فشل في استيراد حالتك',
            success: 'تم استيراد حالتك بنجاح',
          },
          caseLinked: 'الحالة مرتبطة',
          caseTeamInvite: 'تمت الإضافة إلى القضية',
          caseUnlinked: 'الحالة غير مرتبطة',
          dataSanitisation: 'تم تحديث تفاصيل التقرير',
          emptyDescription: 'تحقق لاحقاً للحصول على إشعارات جديدة',
          emptyTitle: 'لقد تابعت كل شيء',
          importId: 'رقم الاستيراد:',
          learnMore: 'تعرف أكثر',
          markAllAsRead: 'قم بوضع علامة على الكل كمقروء',
          newMessage: 'رسالة جديدة',
          newReport: 'تم استلام تقرير جديد',
          permissionRemoved: 'تمت إزالته من القضية',
          postSSubmissionFile: 'تمت إضافة ملف (ملفات) الأدلة',
          report: 'تقرير',
          reportAssigned: 'تم تعيين التقرير لك',
          reportStatusChange: 'تم تغيير حالة التقرير',
          reporterAnonymised: 'تم تجهيل تفاصيلك',
          reporterReportSubmitted: {
            subtitle: 'نوصي بحفظ نسخة من تقريرك',
            title: 'تقرير مقدم',
          },
          mitigationPlanReminder: 'مطلوب الموافقة على خطة التخفيف',
          staleCase: 'حالة غير معالجة',
        },
        privacyStatement: 'بيان الخصوصية',
        reporter: {
          myReports: 'تقاريري',
        },
        settings: 'الإعدادات',
        technicalSupport: 'الدعم الفني',
        title: 'حساب',
      },
      time: {
        day: 'يوم',
        days: 'أيام',
        hour: 'ساعة',
        hours: 'ساعات',
        minute: 'دقيقة',
        minutes: 'دقائق',
        second: 'الثاني',
        seconds: 'ثواني',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'مجهول',
        autoTranslate: 'الترجمة التلقائية مغلقة بشكل افتراضي.',
        backToMessages: 'الرجوع إلى الرسائل',
        caseSettings: 'إعدادات الحالة.',
        changeInProfile:
          'إذا كنت ترغب في تغيير هذا الإعداد، يمكنك القيام بذلك في ملفك الشخصي',
        deletedByMessage: 'حذفت بواسطة {{author}}',
        deletedMessageLabel: 'تم حذف هذه الرسالة',
        description:
          'عند تشغيل الترجمة التلقائية، سيتم ترجمة جميع رسائل التقرير تلقائيًا باستخدام الذكاء الاصطناعي استنادًا إلى اللغة الافتراضية المحددة على المتصفح الخاص بك.',
        descriptionSecondHalf:
          'النسخة الأصلية من جميع الرسائل محفوظة دائمًا ويمكن العثور عليها في المحادثة.',
        messagePlaceholder: 'ابدأ الكتابة...',
        messageSettings: 'إعدادات الرساؤل.',
        originalMessages: 'أصلي',
        showMoreBanner: 'تعرف أكثر على الترجمة الآلية',
        titlev2: 'اقرأ جميع الرسائل بلغتك المفضلة.',
        translatedMessageLabel: 'رسالة مترجمة',
        translatedMessages: 'مترجم',
        understood: 'مفهوم',
      },
      Country: {
        description: 'في أي دولة تعمل؟',
        header: 'في أي دولة تعمل؟',
        noOptions: 'لم يتم العثور على دول',
        other: 'أخرى',
        placeholder: 'ابحث عن دولة...',
      },
      CreatePublicReport: {
        createReport: 'إنشاء تقرير جديد',
        helpPage: 'اذهب إلى صفحة المساعدة الخاصة بنا',
        loginToOpr: 'تسجيل الدخول لتتبع التقارير',
        or: 'أو',
        passwordPlaceholder: 'أدخل كلمة المرور',
        phoneNumberLoginFailed: 'فشل الدخول، رقم الهاتف / الرقم السري غير صحيح',
        phoneNumberPlaceholder: 'أدخل رقم هاتفك',
        phoneNumberTooltip:
          'أدخل رقم الهاتف الذي استخدمته للاتصال بـ VaultTalk',
        pinPlaceholder: 'أدخل الرقم السري',
        reportIntroductionParagraph1:
          'عند الإبلاغ عن حادث، سيتم طرح بعض الأسئلة عليك لمساعدتك في توثيق تجربتك.',
        reportIntroductionParagraph2:
          'قبل تقديمك، لديك الخيار للبقاء مجهول لحماية خصوصيتك.',
        reportIntroductionParagraph3:
          'بعد تقديمك، يمكنك تسجيل الدخول في أي وقت لرؤية تقدم تقريرك والتحدث إلى مدير القضية.',
        reportIssue: 'الإبلاغ عن مشكلة',
        usernameLoginFailed:
          'فشل تسجيل الدخول، اسم المستخدم / كلمة المرور غير صحيحة',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'العلاقة بالشركة مطلوبة',
            reportedCategoryRequired: 'الفئة المبلغ عنها مطلوبة',
          },
        },
        vaultId: 'هوية Vault',
        vaultIdPlaceholder: 'أدخل بريدك الإلكتروني أو معرف Vault',
        vaultIdTooltip:
          'للتقارير المجهولة ، الرقم التعريفي لـ Vault هو أبجدي رقمي. إذا لم يكن التقرير مجهولًا ، فإن الرقم التعريفي لـ Vault هو عنوان بريدك الإلكتروني.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'كلمة المرور الخاصة بك',
        yourPhoneNumber: 'رقم هاتفك',
        yourPin: 'رقمك السري المكون من 6 أرقام',
        yourVaultId: 'هوية Vault الخاصة بك',
      },
      CustomHeader: {
        companyLogo: 'شعار الشركة',
        openReporting: 'فتح إعداد التقارير',
        userSettings: 'إعدادات المستخدم',
      },
      Date: {
        approximateDescription: 'هل تتذكر التاريخ التقريبي الذي وقع فيه الحدث؟',
        approximatePlaceholder: 'مثال: منذ 6 أشهر/العام الماضي/نوفمبر الماضي',
        cancel: 'إلغاء',
        clear: 'محو',
        description: 'هل تتذكر تاريخ وقوع الحدث؟',
        header: 'في أي يوم حدث؟',
        ok: 'موافق',
        placeholder: 'مثال: 21 يونيو 2020',
      },
      Description: {
        whatHappened: 'ماذا حدث؟',
        whatHappenedPlaceholder: 'استخدام كلماتك الخاصة...',
        whatHappenedText: 'بأسلوبك الخاص، صف ما حدث',
      },
      Details: {
        disclaimer:
          'سيتم الكشف عن هذه التفاصيل مع تقريرك. إذا كنت ترغب في البقاء مجهولًا، تأكد من أنها لا تحتوي على معلومات تعريفية.',
        emailPlaceholder: 'البريد الإلكتروني (اختياري)',
        fullNamePlaceholder: 'الاسم الكامل (اختياري)',
        header: 'التفاصيل الخاصة بك',
        nonAnonSubtitle:
          'يرجى تقديم اسمك أو عنوان بريدك الإلكتروني. إذا كنت ترغب في تلقي الإشعارات حول هذا التقرير ، أضف عنوان بريد إلكتروني مناسب أدناه.',
        nonOptionalEmailPlaceholder: 'البريد الإلكتروني',
        nonOptionalFullNamePlaceholder: 'الاسم الكامل',
        subtitle:
          'إذا كنت ترغب في تلقي الإشعارات حول هذا التقرير، أضف عنوان بريد إلكتروني مناسب أدناه.',
      },
      Emotion: {
        description: 'بأي إحساس جعلتك تشعر؟ ماذا كان التأثير؟',
        header: 'ماذا كان التأثير؟',
        placeholder: 'ابدأ الطباعة...',
      },
      Evidence: {
        addedHeading: 'تمت الإضافة',
        deletedMessage: 'تم حذفه',
        deletedStatus: 'تم الحذف',
        failedToOpenFileMessage: 'فشل في فتح الملف. يرجى المحاولة مرة أخرى',
        fileStatuses: {
          infectedUpload: 'محظور بواسطة فحص الأمان',
          passedUpload: 'تم اجتياز فحص الأمان',
          pendingUpload: 'جارٍ التحقق من الأمان',
          readyForDownload: 'جاهز للتحميل',
        },
        mobileErrorMessage: 'ملفات معلمة: راسل مدير قضيتك',
        nameHeading: 'اسم',
        statusHeading: 'الحالة',
        tableTitle: 'أدلة',
        webErrorMessage:
          'ملفات تم وضع علامة عليها: إذا تم وضع علامة على ملفك (ملفاتك)، يرجى إرسال رسالة إلى مدير القضية',
      },
      FileUpload: {
        addFiles: 'أضف الملفات',
        addMoreFiles: 'أضف المزيد من الملفات',
        confirm: 'تأكيد',
        description:
          'إضافة الملفات كدليل يمكن أن تساعد على دعم كفاءة الحل من خلال مدير قضيتك. يرجى النظر في محتوى الملف (بما في ذلك بيانات التعريف للملف) إذا كنت تود البقاء مجهولًا ، واحترام حقوق الأفراد الآخرين والقوانين المعمول بها.',
        dragDrop: 'أسقط الملفات هنا أو',
        errorMessage:
          'فشل في الأرشيف(ـات) بسبب خطأ في الشبكة. اضغط أدناه لإرسال رسالة إلى مدير قضيتك للمساعدة.',
        fileLimit: 'حد حجم كل ملف: 100 ميغابايت',
        fileUploadLimitText: 'يمكنك فقط تحميل 10 ملفات',
        header: 'أضف الأدلة',
        helpArticle: 'مقالة المساعدة',
        highlighted: 'تصفح الملفات',
        information: 'أنواع الملفات المدعومة',
        moreInformation:
          'لمزيد من المعلومات، يرجى الاطلاع على هذا <a>مقالة المساعدة</a>',
        postSubmissionErrorMessage:
          "لم نتمكن من تحميل ملفاتك بسبب خطأ في النظام. الرجاء اختيار 'تأكيد' مرة أخرى.",
        tooltipAudio: 'الصوت:',
        tooltipAudioOptions: '.ogg، .wav، .wma',
        tooltipDocuments: 'وثائق:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'الصور:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'نص:',
        tooltipTextOptions: '.txt، .csv، .html، .xml',
        tooltipVideo: 'فيديو:',
        tooltipVideoOptions: '.mp4، .mov، .mp1s، .asf',
        uploadErrors: {
          invalidFileSize: 'الملف كبير جدا',
          invalidFileType: 'نوع الملف غير مدعوم: {{extension}}',
          systemError: 'خطأ في النظام',
          tooManyFiles: 'العدد الأقصى للملفات هو {{maxFiles}}',
        },
        uploadFiles: 'تحميل الملفات',
      },
      Loading: {
        loading: 'يرجى الانتظار بينما نقدم تقريرك إلى مدير القضية...',
        postSubmissionLoading: 'يرجى الانتظار بينما نقوم بإرسال ملفاتك...',
      },
      Location: {
        description: 'أين حدث هذا؟',
        header: 'أين حدث هذا؟',
        placeholder: 'مثال: في المكتب',
      },
      MessageListBox: {
        messageCaseManager: 'مدير حالة الرسائل',
        report: 'تقرير {{displayReportId}}‎ ‎{{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'الترجمة معطلة',
        enableTranslationLabelEnabled: 'تم تفعيل الترجمة',
        enableTranslationsDescription:
          'قم بتمكين الترجمة التلقائية وقراءة جميع رسائل التقرير بلغتك المفضلة. اللغة المترجمة تعتمد على اللغة المحددة على جهازك.',
        enableTranslationsHeader: 'تمكين الترجمة التلقائية لرسائل التقرير',
        enableTranslationsSubDescriptionv2:
          'يمكنك التبديل بين اللغة المترجمة واللغة الأصلية في كل محادثة.',
        updateTranslationFailed: 'فشل تحديث الترجمة',
        updateTranslationSuccess: 'تم تحديث إعدادات الترجمة بنجاح',
      },
      Password: {
        changePasswordHeader: 'تغيير كلمة المرور',
        createNewPassword: 'الرجاء إنشاء كلمة مرور جديدة',
        createPasswordHeader: 'كلمة المرور الخاصة بك',
        currentPasswordPlaceholder: 'أدخل كلمة المرور الحالية',
        description:
          'يجب أن تتكون كلمة المرور الصالحة من 9 حروف على الأقل وأن تشتمل على حرف كبير واحد ورقم واحد.',
        enterCurrentPassword: 'الرجاء إدخال كلمة المرور الحالية',
        forgottenPasswordInstructions:
          'أدخل رقم Vault الألفاني (ليس عنوان بريدك الإلكتروني) وعنوان بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك.',
        newDescription:
          'أنشئ كلمة مرور قوية للحفاظ على أمان حسابك. ابدأ الكتابة لرؤية الإرشادات أدناه.',
        passwordPlaceholder: 'إنشاء كلمة مرور',
        passwordResetRequestedDescription:
          'إذا كان معرف Vault موجودًا في نظامنا، ستتلقى بريدًا إلكترونيًا مع التعليمات لإعادة تعيين كلمة المرور الخاصة بك.',
        passwordResetRequestedHeader: 'تم طلب رابط إعادة تعيين كلمة المرور',
        reenterPlaceholder: 'أدخل كلمة المرور مرة أخرى',
        subtitle: 'أنشئ كلمة مرور لإرسال هذا التقرير والوصول إليه في المستقبل',
        yourVaultId: 'هويتك Vault',
        yourVaultIdPlaceholder:
          'أدخل معرف Vault الخاص بك (مثلاً {{exampleId}})',
      },
      Perpetrators: {
        description:
          'هل تقوم بالإبلاغ عن شخص معين أم عدة أشخاص؟ هل يمكنك تسميته أو وصفه؟',
        header: 'الأشخاص المتورطين',
        placeholder:
          'ابدأ في الكتابة واستخدم الفاصلة لإضافة أسماء أو أوصاف متعددة',
      },
      PoweredByVault: 'بإدارة من {{company}}',
      PrivacyStatement: 'بيان الخصوصية للمنتج',
      PublicMessageList: {
        myMessages: 'رسائلي',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'تمت إضافة الأدلة إلى التقرير الحالي',
        backToReportId: 'العودة إلى تقرير الهوية: {{reportId}}',
        description:
          'إضافة الملفات كدليل يمكن أن يساعد في دعم فعالية الحل من قبل مدير القضية. يرجى النظر في محتوى الملف (بما في ذلك بيانات التعريف الخاصة بالملف) إذا كنت ترغب في البقاء مجهولًا ، واحترام حقوق الأفراد الآخرين والقوانين المعمول بها. للمزيد من المعلومات، يرجى الاطلاع على هذا <a>مقالة المساعدة</a>',
        header: 'أضف أدلة إضافية إلى التقرير',
        vaultTalkOpenCaseHeader: 'أضف الأدلة إلى تقريرك',
      },
      PublicReport: {
        anonymous: 'مجهول',
        backToReports: 'الرجوع إلى التقارير',
        skipped: 'تم التخطي',
      },
      PublicReportCard: {
        addEvidence: 'أضف أدلة إضافية',
        messageCaseManager: 'مدير حالة الرسائل',
        reportId: 'مُعرف التقرير: ',
        submitted: 'تم الإرسال',
        vaultTalkClosedCaseCTA: 'عرض الأدلة',
        vaultTalkOpenCaseCTA: 'أضف دليل',
        viewAdditionalEvidence: 'عرض أدلة إضافية',
        viewReport: 'عرض التقرير',
      },
      PublicReportsList: {
        reportingSystem: 'نظام الإبلاغ',
      },
      Question: {
        placeholder: 'ابدأ الكتابة...',
        question: 'قدم التفاصيل',
        questionText: 'يرجى مشاركة مخاوفك أو التحديث أو الاستفسار معنا.',
      },
      Relationship: {
        header: 'علاقتك بالمنظمة',
        tellUsAbout: 'من فضلك أخبرنا عن علاقتك بالمنظمة.',
      },
      ResponsiveNavMenu: {
        messages: 'رسائلي',
        reports: 'تقاريري',
      },
      Site: {
        description: 'في أي موقع تعمل؟',
        header: 'في أي موقع تعمل؟',
        noOptions: 'لم يتم العثور على مواقع',
        other: 'أخرى',
        placeholder: 'ابحث عن موقع...',
      },
      SpamPuzzle: {
        dialog: 'للمتابعة، الرجاء حل هذه الأحجية',
      },
      SubmissionTypes: {
        reportIssue: 'اختر فئة',
        whatType: 'اختر الفئة التي تصف تقريرك أفضل',
      },
      SubmitSuccess: {
        category: '<bold>الفئة:</bold> {{category}}',
        country: '<bold>الدولة:</bold> {{country}}',
        dateSubmitted: '<bold>تاريخ التقديم:</bold> {{date}}',
        recordYourVaultID: 'تذكر هذه المعلومات لتسجيل الدخول',
        successInformation: 'مزيد من المعلومات',
        successMessage:
          'تم تقديم تقريرك وهو جاهز للمراجعة. سيتم تمييز أي ملفات مرفقة تتطلب الاهتمام عند تسجيل الدخول. قم بتسجيل الدخول أدناه لعرض تحديثات التقرير وإرسال رسالة إلى مدير الحالة الخاص بك.',
        successSanitationMessage:
          'احفظ نسخة لسجلاتك، واحتفظ بالخاص بك Vault-ID في مكان آمن - ستحتاجه للوصول إلى التحديثات وإرسال رسالة إلى مدير حالتك.',
        successSanitationTagline: 'تم تقديم تقريرك وتخزينه بأمان.',
        successThankYou: 'شكراً على تقريرك!',
        viewReport: 'عرض التقرير',
      },
      Time: {
        approximateDescription: 'هل تتذكر الوقت التقريبي الذي وقع فيه الحدث؟',
        approximatePlaceholder: 'مثال: في الصباح، بعد الظهر',
        description: 'هل تتذكر الوقت الذي وقع فيه الحدث؟',
        header: 'في أي وقت حدث؟',
        invalidTime: 'يجب أن يكون تنسيق الوقت HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'تغيير كلمة المرور',
        closeDialog: 'إغلاق الحوار',
        logout: 'تسجيل الدخول',
        messageSettings: 'إعدادات الرسالة',
        userSettings: 'إعدادات المستخدم',
      },
      Witnesses: {
        description: 'هل أخبرت أي شخص آخر أو رأى أي شخص ما حدث؟',
        header: 'هل يوجد أي شهود؟',
        placeholder: 'ابدأ الطباعة...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'إرسال رسالة',
        title: 'مدير القضية',
        translationHeader: 'تعرف أكثر على الترجمات التلقائية',
      },
      ReportCard: {
        addEvidence: 'أضف دليل',
        submissionModeVia: 'عبر {{submissionMode}}',
        viewEvidence: 'عرض الأدلة',
      },
      ReportList: {
        yourReports: 'تقاريرك',
      },
      ReportingActivate: {
        buttonText: 'استمر',
        description:
          'إذا كانت منظمتك قد سجلتك للحصول على حساب، سنرسل لك بريدًا إلكترونيًا بتعليمات لإكمال الإعداد.',
        emailInput: 'بريد إلكتروني',
        header: 'أدخل بريدك الإلكتروني العملي',
        successAccount:
          'إذا كانت منظمتك قد سجلتك للحصول على حساب، سنرسل لك بريدًا إلكترونيًا بتعليمات لإكمال الإعداد.',
        successEmail:
          'إذا لم تره فورًا، يرجى الانتظار بضع دقائق وتحديث صندوق بريدك الإلكتروني.',
        successHeading: 'شكرا لك',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'أضف الأدلة إلى تقريرك',
        descriptionText:
          'إضافة الملفات كدليل يمكن أن يساعد في دعم كفاءة الحل من قِبل مدير قضيتك. يرجى النظر في محتوى الملف (بما في ذلك بيانات التعريف للملف) إذا كنت ترغب في البقاء مجهولًا ، واحترام حقوق الأفراد الآخرين والقوانين المعمول بها. لمزيد من المعلومات، يرجى الاطلاع على هذا <a>مقال المساعدة</a>',
        emptyMessage: 'لم يتم تحميل أي أدلة إضافية',
      },
      ReportingChangePassword: {
        back: 'العودة',
        description:
          'قم بإنشاء كلمة مرور قوية للحفاظ على أمان حسابك. ابدأ في الكتابة لرؤية الإرشادات أدناه.',
        errorToast: 'لا يمكن إنشاء كلمة المرور ، الرمز غير صالح.',
        header: 'تغيير كلمة المرور',
        incorrectCurrentPassword:
          'كلمة المرور الحالية خاطئة. يرجى التحقق منها والمحاولة مرة أخرى.',
        invalidToken: 'رمز غير صالح',
        passwordUpdated: 'تم تحديث كلمة المرور',
        passwordUpdatedDescription:
          'تم تحديث كلمة المرور الخاصة بك بنجاح. شكراً لك على اتخاذ هذه الخطوة للحفاظ على بياناتك آمنة!',
        passwordUsedBefore: 'غير مسموح بإعادة استخدام كلمة المرور',
        passwordUsedBeforeDescription:
          'من أجل سلامتك، لا يمكنك إعادة استخدام أي من آخر ست كلمات مرور لك. الرجاء اختيار كلمة مرور جديدة وفريدة للحفاظ على أمان حسابك وحاول مرة أخرى.',
        toastDescription:
          'تم تحديث كلمة المرور الخاصة بك بنجاح. شكراً لك على اتخاذ هذه الخطوة للحفاظ على أمان بياناتك!',
        toastMessage: 'تم تحديث كلمة المرور',
        updatePasswordCTA: 'تحديث كلمة المرور',
      },
      ReportingConnect: {
        cancelButton: 'إلغاء',
        connectButton: 'اتصل',
        disclaimer:
          'ربط حساب Slack الخاص بك بحساب Vault الخاص بك يضمن اتصال آمن وخاص.<br /><br />بالربط، يمكنك الإبلاغ عن سلوك غير لائق أو طرح سؤال مباشرة داخل Slack. ستكون لديك دائمًا الخيار للإبلاغ بشكل مجهول بعد الربط. خصوصيتك وأمانك هما أولوياتنا الأولى.',
        heading:
          'تطلب Vault Platform الإذن للوصول إلى حساب Slack {{organisationName}} الخاص بك',
        listHeading: 'ما الذي سيتمكن Vault من القيام به؟',
        permissionIdentity: {
          extraInfo: 'سيكون لـ Vault القدرة على عرض هوية مستخدم Slack الخاص بك',
          heading: 'عرض معلومات حول هوية المستخدم',
        },
        permissionNotifications: {
          extraInfo:
            'سيتمكن Vault من إرسال إشعارات لك حساب Slack الخاص بك، بشأن أي تحديثات على التقرير المقدم أو السؤال',
          heading: 'إرسال إشعارات لك',
        },
        permissionOverview: {
          extraInfo:
            'سيقدم Vault نظرة عامة على جميع التقديمات في الصفحة الرئيسية',
          heading: 'نظرة عامة على الطلبات',
        },
        permissionSubmitReport: {
          extraInfo:
            'سيمنح هذا Vault إذنًا لتقديم تقرير أو طرح سؤال ، مباشرة إلى مؤسستك ، من Slack',
          heading: 'قدم تقريرًا أو سؤالًا نيابة عنك',
        },
        successfulConnectionDescription:
          'تم الآن ربط حساب Vault وحساب Slack الخاص بك. يمكنك الآن إغلاق هذا العلامة التبويب والعودة إلى Slack.',
        successfulConnectionHeading: 'تم الاتصال بنجاح',
        unsuccessfulConnectionDescription:
          'حدث خطأ ما. يرجى إغلاق هذا العلامة والعودة إلى Slack للمحاولة مرة أخرى.',
        unsuccessfulConnectionHeading: 'فشل الاتصال',
      },
      ReportingForgotPassword: {
        description:
          'أدخل عنوان البريد الإلكتروني المرتبط بحسابك، وسنرسل لك رابط لإعادة تعيين كلمة المرور الخاصة بك.',
        heading: 'كلمة السر المنسية',
        invalidTokenError: 'لا يمكن إنشاء كلمة المرور، رمز غير صالح.',
        passwordReuseError: 'غير مسموح بإعادة استخدام كلمة المرور',
        passwordReuseErrorDescription:
          'من أجل سلامتك، لا يمكنك إعادة استخدام أي من كلمات المرور الستة الأخيرة. يرجى اختيار كلمة مرور جديدة وفريدة للحفاظ على أمان حسابك وحاول مرة أخرى.',
        sendLink: 'أرسل رابط إعادة التعيين',
        sendLinkFailure: 'حدث خطأ ما',
        sendLinkFailureDescription:
          'عُد إلى <a>Reporter Hub</a> وحاول مرة أخرى. إذا استمرت المشكلة، اتصل بنا على <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'تم إرسال رابط إعادة تعيين كلمة المرور',
        sendLinkSuccessDescription:
          'لقد أرسلنا رابط إعادة تعيين كلمة المرور إلى {{email}}',
        updatePasswordSuccess: 'تم تحديث كلمة المرور',
        updatePasswordSuccessDescription:
          'تم تحديث كلمة المرور الخاصة بك بنجاح. شكراً لك لاتخاذ هذه الخطوة للحفاظ على أمان بياناتك!',
      },
      ReportingLogin: {
        accountFrozen: 'الحساب مجمد',
        accountLocked:
          'تم محاولة تسجيل الدخول أكثر من اللازم بشكل غير صحيح. تم قفل الحساب لمدة تصل إلى ساعة واحدة. لا يمكن إعادة تعيين كلمة المرور خلال هذا الوقت.',
        accountLockedPermanently:
          'تم قفل حسابك. استخدم إعادة تعيين كلمة المرور لاستعادة الوصول أو اتصل بمسؤول النظام للمساعدة الإضافية.',
        createAccountCTA: 'سجل للحصول على حساب',
        currentPassword: 'كلمة المرور الحالية',
        emailLabel: 'بريدك الإلكتروني',
        forgotPassword: 'هل نسيت كلمة المرور الخاصة بك؟',
        loginButton: 'تسجيل الدخول',
        newPasswordPlaceholder: 'كلمة السر الجديدة',
        passwordFailMessage:
          'عد إلى تطبيق Vault في Slack وحاول مرة أخرى. إذا استمرت المشكلة، فاتصل بنا على techsupport@vaultplatform.com',
        passwordFailTitle: 'حدث خطأ ما',
        passwordLabel: 'كلمة مرورك',
        passwordPlaceholder: 'أدخل كلمة مرورك',
        passwordResetRequired: 'مطلوب إعادة تعيين كلمة المرور',
        passwordSuccessfullySetMessage:
          'عد إلى تطبيق Vault في Slack واعتمد باستخدام كلمة المرور الجديدة لتكمل من حيث توقفت.',
        passwordSuccessfullySetTitle: 'تم تعيين كلمة المرور بنجاح',
        reenterPlaceholder: 'أعد إدخال كلمة المرور',
        title: 'مركز الصحفي',
        tooltip:
          'إذا لم تقم بتعيين كلمة مرور لتطبيق Vault بعد، اتبع الرابط هنا للبدء. إذا نسيت كلمة المرور الخاصة بك، استخدم رابط "نسيت كلمة المرور" أدناه.',
        usernameLoginFailed:
          'فشل تسجيل الدخول ، اسم المستخدم أو كلمة المرور غير صحيحة',
      },
      ReportingReset: {
        failureDescription:
          'عد إلى تطبيق Vault في Slack وحاول مرة أخرى. إذا استمرت المشكلة، اتصل بنا على <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'حدث خطأ ما',
        successDescription:
          'عد إلى تطبيق Vault في Slack وقم بالمصادقة باستخدام كلمة المرور الجديدة الخاصة بك للاستمرار من حيث توقفت',
        successHeading: 'تم تعيين كلمة المرور بنجاح',
      },
      noReports: {
        description:
          'سيتم عرض جميع التقارير المقدمة هنا. تعلم المزيد حول الطرق التي يمكنك من خلالها تقديم تقرير في',
        descriptionHelpArticle: 'هذه مقالة المساعدة',
        errorDescription:
          'نحن نعاني من صعوبة في تحميل تقاريرك. يرجى محاولة تحديث الصفحة.',
        errorDescriptionSecondary: 'إذا لم يعمل ذلك، يرجى التواصل معنا على',
        errorTitle: '⚠️ عفوًا، حدث خطأ ما',
        title: 'ليس لديك تقارير بعد',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'قم بتمكين الترجمات التلقائية واقرأ جميع رسائل التقرير باللغة التي تفضلها. اللغة المترجمة تعتمد على اللغة المختارة على جهازك.',
          autoTranslationDescription2:
            'يمكنك التبديل بين اللغة المترجمة واللغة الأصلية في كل محادثة.',
          autoTranslationTitle: 'تمكين الترجمة التلقائية لرسائل التقرير',
          header: 'إعدادات الرسائل',
          subHeader: 'قم بتكوين كيفية عرض الرسائل',
        },
        notificationSettings: {
          emailDescription:
            'استلم إشعارات البريد الإلكتروني للتحديثات المهمة على تقاريرك',
          emailTitle: 'إشعارات البريد الإلكتروني',
          header: 'إعدادات الإشعارات',
          subHeader: 'قم بتكوين كيفية تلقي الإشعارات',
        },
        title: 'الإعدادات',
        updatedSettingsFailure: 'فشل في تحديث إعداداتك',
        updatedSettingsSuccess: 'تم تحديث إعداداتك بنجاح',
      },
    },
    validators: {
      passwordLength: 'يجب أن تتكون كلمة المرور من 9 أحرف على الأقل',
      passwordLowercase:
        'يجب أن تحتوي كلمة المرور على حرف صغير واحد 1 على الأقل',
      passwordMissMatch: 'يجب أن تتطابق حقول كلمة المرور والتأكيد.',
      passwordNumeric: 'يجب أن تحتوي كلمة المرور على رقم واحد 1 على الأقل',
      passwordUppercase:
        'يجب أن تحتوي كلمة المرور على حرف كبير واحد 1 على الأقل',
    },
    validatorsNew: {
      passwordLength: 'بين 10 و 30 حرف',
      passwordLowercase: 'على الأقل حرف واحد صغير',
      passwordMissMatch: 'كلمات السر لا تتطابق',
      passwordNumeric: 'على الأقل رقم واحد',
      passwordSpecialCharacter: 'على الأقل حرف خاص واحد',
      passwordUppercase: 'على الأقل حرف واحد كبير',
    },
  },
};

export default translations;
